import { useMemo, useState } from 'react';
import { USER_AGREEMENT } from '../../licensionAgreement/constants';

// eslint-disable-next-line import/prefer-default-export
export const useAgreement = () => {
  const [agreement, setAgreement] = useState(localStorage.getItem(USER_AGREEMENT.KEY));
  const handleAgree = () => {
    localStorage.setItem(USER_AGREEMENT.KEY, USER_AGREEMENT.VALUE);
    setAgreement('true');
  };
  return useMemo(() => ({ agreement, handleAgree }), [agreement]);
};
